import React, { useContext } from 'react'
import BlogContext from '../../../contexts/blogData/blogData'
import CampingContext from '../../../contexts/campingData/campingData'
import {
  getCurrentVideo,
  getVideosByIds,
  randomizeVideos,
} from '../suggestedVideoHelpers'
import SuggestedVideos from '../SuggestedVideos'
import VideoContext from '../../../contexts/videoData/videoData'
import PropTypes from 'prop-types'

const computeAllCampingVideosForSinglePost = (
  reviewId,
  allPosts,
  allVideos
) => {
  const currentVideo = getCurrentVideo(allVideos, reviewId)
  const remainingVideos = allPosts
    .filter(video => video.videoId !== reviewId)
    .map(video => video.videoId)
  return [
    ...currentVideo,
    ...randomizeVideos(getVideosByIds(remainingVideos, allVideos)).slice(0, 2),
  ]
}

const AllVideosForSinglePost = ({ reviewId, type }) => {
  const allVideos = useContext(VideoContext)
  const allCampingReviews = type === 'camping' ? useContext(CampingContext) : []
  const allBlogPosts = type === 'adventure' ? useContext(BlogContext) : []
  const allPosts = [...allCampingReviews, ...allBlogPosts]

  return (
    <SuggestedVideos
      videos={computeAllCampingVideosForSinglePost(
        reviewId,
        allPosts,
        allVideos
      )}
    />
  )
}

AllVideosForSinglePost.propTypes = {
  reviewId: PropTypes.string,
  type: PropTypes.string,
}

export default AllVideosForSinglePost
